import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ChatService } from 'src/app/services/chat.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-vincular-contatos',
  templateUrl: './modal-vincular-contatos.component.html',
  styleUrls: ['./modal-vincular-contatos.component.scss']
})
export class ModalVincularContatosComponent implements OnInit, OnDestroy {
  @Input() contatos;
  nomes: string[] = [];
  emails: string[] = [];
  celulares: string[] = [];
  telefones: string[] = [];
  contatoFinal = {
    contato_selecionado_ids: [],
    contato_agregador_novo: {
      descricao: null,
      email: null,
      celular: null,
      telefone: null
    }
  };
  newSubs: Subscription;

  constructor(
    public modal: NgbActiveModal,
    private chatService: ChatService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.contatos.forEach(cont => {
      this.contatoFinal.contato_selecionado_ids.push(cont.id as never);

      if (!this.contatoFinal.contato_agregador_novo.descricao) {
        this.contatoFinal.contato_agregador_novo.descricao = cont.descricao;
      }

      if (!this.contatoFinal.contato_agregador_novo.email) {
        this.contatoFinal.contato_agregador_novo.email = cont.email;
      }

      if (!this.contatoFinal.contato_agregador_novo.celular) {
        this.contatoFinal.contato_agregador_novo.celular = cont.celular;
      }

      if (!this.contatoFinal.contato_agregador_novo.telefone) {
        this.contatoFinal.contato_agregador_novo.telefone = cont.telefone;
      }

      if (cont.descricao && !this.nomes.includes(cont.descricao)) {
        this.nomes.push(cont.descricao);
      }

      if (cont.email && !this.emails.includes(cont.email)) {
        this.emails.push(cont.email);
      }

      if (cont.celular && !this.celulares.includes(cont.celular)) {
        this.celulares.push(cont.celular);
      }

      if (cont.telefone && !this.telefones.includes(cont.telefone)) {
        this.telefones.push(cont.telefone);
      }
    });
  }

  ngOnDestroy(): void {
    this.newSubs?.unsubscribe();
  }

  close(results?: any): void {
    this.modal.close(results);
  }

  vincularContatos(): void {
    Swal.fire({
      html: this.translate.instant('ALERTA_VINCULO_CONTATOS_HTML'),
      icon: 'warning',
      confirmButtonText: this.translate.instant('SIM'),
      showCancelButton: true,
      cancelButtonText: this.translate.instant('NAO'),
      position: 'top',
      customClass: {
        content: 'swal-only-text'
      }
    }).then(results => {
      if (results.isConfirmed) {
        this.newSubs = this.chatService.vinculoContatos(this.contatoFinal)
          .subscribe({
            next: (results) => {
              this.close(true);
            }, error: (error) => console.error('vincularContatos', error)
          });
      }
    });
  }
}
